import {
  type CipherText,
  purchaseApi,
  type QuoteRequest,
} from "@b2bportal/purchase-api";
import { NETWORK_CALL_FAILED, type IApiConfig } from "@hopper-b2b/types";
import type { RawAxiosRequestConfig } from "axios";
import { axiosInstance } from "../AxiosInterceptor";
import { trackEvent } from "../tracking/trackEvent";

export const scheduleQuote = (
  req: QuoteRequest,
  options?: RawAxiosRequestConfig,
  apiConfig?: IApiConfig
): Promise<CipherText> =>
  new Promise((resolve, reject) => {
    purchaseApi(axiosInstance)
      .apiV1PurchaseQuoteSchedulePost(req, options)
      .then((res) => {
        const responseBody = res.data;
        resolve(responseBody);
      })
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          apiConfig
        );
        reject(e);
      });
  });

export interface SchedulePriceQuoteRequest {
  tripId: string;
  seatedPassengers: string[];
  lapInfants: string[];
  fareId: string;
  emailAddress: string;
  phoneNumber: string;
  ancillaryIds: string[];
  priceDropCandidateId?: string;
  delegatedTo?: string;
}
